import React, { Component } from 'react';
import { connect } from 'react-redux';
import PageContainer from 'pages/container';
import LoadingBar from 'components/loading-bar';
import TabBar from 'components/tab-bar';
import SubNavTab from 'components/sub-nav-tab';
import PlayersTable from 'components/players-table';
import { getPlayersRequest } from 'actions/pages/players';
import { SEASON_ID } from 'config';

const TAB_TWDTD = {
  id: 'twdtd',
  division: 'twdtd',
  title: 'TWDTD',
  ship: 1,
};

const TAB_TWDTJ = {
  id: 'twdtj',
  division: 'twdtj',
  title: 'TWDTJ',
  ship: 2,
};

const TAB_TWDTB_SPIDER = {
  id: 'twdtb-spider',
  division: 'twdtb',
  title: 'TWDTB Spider',
  ship: 3,
};

const TAB_TWDTB_TERR = {
  id: 'twdtb-terr',
  division: 'twdtb',
  title: 'TWDT Terr',
  ship: 5,
};

const TAB_TWDTB_SHARK = {
  id: 'twdtb-shark',
  division: 'twdtb',
  title: 'TWDT Shark',
  ship: 8,
};

const TABS = [
  TAB_TWDTD,
  TAB_TWDTJ,
  TAB_TWDTB_SPIDER,
  TAB_TWDTB_TERR,
  TAB_TWDTB_SHARK,
];

class Players extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: TAB_TWDTD,
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    dispatch(getPlayersRequest(SEASON_ID));
  }

  selectTab = (tab) => {
    const { selectedTab } = this.state;

    if (selectedTab !== tab) {
      this.setState({
        selectedTab: tab,
      });
    }
  };

  render() {
    const { page } = this.props;
    const { divisions, requests } = page;
    const { selectedTab } = this.state;

    let content;

    if (requests.getPlayers.success) {
      if (divisions[selectedTab.division.toUpperCase()]) {
        const players =
          divisions[selectedTab.division.toUpperCase()][selectedTab.ship];

        content = (
          <div className="content">
            <PlayersTable type={selectedTab.id} players={players} />
          </div>
        );
      } else {
        content = <p className="intro">No stats available.</p>;
      }
    } else {
      content = <LoadingBar />;
    }

    return (
      <PageContainer
        className="players"
        title="Players & Stats"
        subtitle="Players and various statistics">
        <TabBar>
          {TABS.map((tab) => (
            <SubNavTab
              key={tab.id}
              {...tab}
              onClick={() => {
                this.selectTab(tab);
              }}
              selected={selectedTab === tab}
            />
          ))}
        </TabBar>
        {content}
      </PageContainer>
    );
  }
}

const mapStateToProps = (state) => ({
  app: state.app,
  page: state.pages.players,
});

export default connect(mapStateToProps)(Players);



// WEBPACK FOOTER //
// ./src/pages/players/players.js